import React from 'react';
import { BdsButton, BdsGrid } from 'blip-ds/dist/blip-ds-react';

interface ModalFooterProps {
  cancelText: string;
  saveText: string;
  isLoading: boolean;
  isFormValid: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export const ModalFooter: React.FC<ModalFooterProps> = ({
  cancelText,
  saveText,
  isLoading,
  isFormValid,
  onCancel,
  onSave,
}) => {
  return (
    <BdsGrid gap="1" justifyContent="flex-end">
      <BdsButton variant="outline" onClick={onCancel} disabled={isLoading}>
        {cancelText}
      </BdsButton>
      <BdsButton onClick={onSave} disabled={!isFormValid || isLoading} bdsLoading={isLoading}>
        {saveText}
      </BdsButton>
    </BdsGrid>
  );
};
